module.exports = __webpack_public_path__ + "img/IMG_0801.686f7b46.jpeg";